var _rect, _path, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginLinea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 17,
    viewBox: "0 0 216 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 8,
    width: 97.5,
    height: 1,
    fill: "#E6E9FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.944 8.988C112.944 9.73933 112.825 10.43 112.587 11.06C112.349 11.6853 112.013 12.2243 111.579 12.677C111.145 13.1297 110.622 13.482 110.011 13.734C109.404 13.9813 108.732 14.105 107.995 14.105C107.257 14.105 106.585 13.9813 105.979 13.734C105.372 13.482 104.852 13.1297 104.418 12.677C103.984 12.2243 103.648 11.6853 103.41 11.06C103.172 10.43 103.053 9.73933 103.053 8.988C103.053 8.23667 103.172 7.54833 103.41 6.923C103.648 6.293 103.984 5.75167 104.418 5.299C104.852 4.84167 105.372 4.487 105.979 4.235C106.585 3.983 107.257 3.857 107.995 3.857C108.732 3.857 109.404 3.983 110.011 4.235C110.622 4.487 111.145 4.84167 111.579 5.299C112.013 5.75167 112.349 6.293 112.587 6.923C112.825 7.54833 112.944 8.23667 112.944 8.988ZM111.551 8.988C111.551 8.372 111.467 7.819 111.299 7.329C111.131 6.839 110.893 6.426 110.585 6.09C110.277 5.74933 109.903 5.488 109.465 5.306C109.026 5.124 108.536 5.033 107.995 5.033C107.458 5.033 106.97 5.124 106.532 5.306C106.093 5.488 105.717 5.74933 105.405 6.09C105.097 6.426 104.859 6.839 104.691 7.329C104.523 7.819 104.439 8.372 104.439 8.988C104.439 9.604 104.523 10.157 104.691 10.647C104.859 11.1323 105.097 11.5453 105.405 11.886C105.717 12.222 106.093 12.481 106.532 12.663C106.97 12.8403 107.458 12.929 107.995 12.929C108.536 12.929 109.026 12.8403 109.465 12.663C109.903 12.481 110.277 12.222 110.585 11.886C110.893 11.5453 111.131 11.1323 111.299 10.647C111.467 10.157 111.551 9.604 111.551 8.988Z",
    fill: "#828282"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 8,
    width: 97.5,
    height: 1,
    fill: "#E6E9FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLinea);
export default __webpack_public_path__ + "static/media/login_linea.a107eeb8f5195c5f1a9f8f7e087d6608.svg";
export { ForwardRef as ReactComponent };